var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Moment from 'react-moment';
import config from '../../config';
var DateTime = function (props) {
    props = __assign({ format: config.display_date_time_format }, props);
    return React.createElement(Moment, __assign({}, props));
};
export default DateTime;
